(()=>{
  const syncSticky=(section,select)=>{
    if(!section)return;
    const sticky=section.querySelector('[data-sticky-add]');
    if(!sticky)return;
    let available;
    if(select){
      const option=select.options[select.selectedIndex];
      available=option?.dataset.available==='true';
    }else{
      const variantSelect=section.querySelector('[data-variant-select]');
      if(variantSelect){
        const option=variantSelect.options[variantSelect.selectedIndex];
        available=option?.dataset.available==='true';
      }else{
        const main=section.querySelector('[data-main-add]');
        available=main?!main.disabled:false;
      }
    }
    sticky.disabled=!available;
    sticky.textContent=available?'Add to cart':'Sold out';
  };

  const initSticky=(scope=document)=>{
    if(scope.matches?.('[data-product-section]'))syncSticky(scope);
    scope.querySelectorAll?.('[data-product-section]').forEach(section=>syncSticky(section));
  };

  const initTabs=(scope=document)=>{
    scope.querySelectorAll('[data-fusion-tabs]').forEach(section=>{
      if(section.dataset.fusionReady==='true') return;
      section.dataset.fusionReady='true';
      const tabs=[...section.querySelectorAll('[data-fusion-tab]')];
      const panels=[...section.querySelectorAll('[data-fusion-panel]')];
      const activate=(id)=>{
        tabs.forEach(tab=>{const active=tab.dataset.fusionTab===id;tab.setAttribute('aria-selected',active?'true':'false');tab.tabIndex=active?0:-1;});
        panels.forEach(panel=>panel.hidden=panel.dataset.fusionPanel!==id);
      };
      tabs.forEach(tab=>tab.addEventListener('click',()=>activate(tab.dataset.fusionTab)));
      tabs.forEach((tab,index)=>tab.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key)) return;e.preventDefault();const next=e.key==='ArrowRight'?(index+1)%tabs.length:(index-1+tabs.length)%tabs.length;tabs[next].focus();activate(tabs[next].dataset.fusionTab);}));
    });
  };

  initTabs();
  initSticky();
  document.addEventListener('change',e=>{const select=e.target.closest?.('[data-variant-select]');if(select)syncSticky(select.closest('[data-product-section]'),select);});
  document.addEventListener('shopify:section:load',e=>{initTabs(e.target);initSticky(e.target);});
})();
